export default {
  'CATEGORY' (state) {
    return state.category
  },
  'CATEGORIES' (state) {
    return state.categories
  }
}
